'use client';

import { createContext, useContext, useState } from 'react';

type RatePlanContextValue = {
  selectedRatePlanId: string;
  setSelectedRatePlanId: (id: string) => void;
};

const RatePlanContext = createContext<RatePlanContextValue | null>(null);

export function RatePlanProvider({
  initialRatePlanId = '',
  children,
}: {
  initialRatePlanId?: string;
  children: React.ReactNode;
}) {
  const [selectedRatePlanId, setSelectedRatePlanId] = useState(initialRatePlanId);

  return (
    <RatePlanContext.Provider value={{ selectedRatePlanId, setSelectedRatePlanId }}>
      {children}
    </RatePlanContext.Provider>
  );
}

export function useRatePlanSelection() {
  return useContext(RatePlanContext);
}
